import { Locale, currentMarket } from 'const';

export const formatNumber = (value: number, locale?: Locale, options?: Intl.NumberFormatOptions) => {
  const newLocale = locale ?? currentMarket.locale;

  return new Intl.NumberFormat(newLocale, options).format(value);
};
